import { addNotify } from 'features/notify';
import { SlotsHistoryActionDataTypes } from './reducer';

const setActionProcessing = actionProcessing => {
  return async (dispatch, getState, extra) => {
    dispatch({
      type: SlotsHistoryActionDataTypes.ACTION_PROCESSING,
      payload: actionProcessing,
    });
  };
};

const getSlotsHistory = formData => async (dispatch, getState, extra) => {
  const { api } = extra;
  const errorStatusMessage = getState().locale.locale;
  const { isAuth } = getState().auth;

  if (!isAuth || !formData.user_id) return;

  dispatch(setActionProcessing(true));

  const response = await api.slotsHistory.getSlotsHistory(formData);

  const errorMessage = errorStatusMessage[response.codeStatus] || getState().locale.locale.defaultMessage;
  if (response.success) {
    dispatch({
      type: SlotsHistoryActionDataTypes.GET_SLOTS_HISTORY_SUCCESS,
      payload: {
        list: response.data.list,
        pageCount: response.data.pageCount,
      },
    });
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch(setActionProcessing(false));
};

const resetSlotsHistory = () => {
  return async (dispatch, getState, extra) => {
    dispatch({
      type: SlotsHistoryActionDataTypes.RESET_SLOTS_HISTORY,
    });
  };
};

export { getSlotsHistory, resetSlotsHistory };
